module.exports = __webpack_public_path__ + "img/circle_error_excl.b3445820.svg";